// export  DsfMessageNotice from './messageNotice';

export const DsfMessageNotice = dsf.defineAsyncComponent("DsfMessageNotice", () => import(/*webpackChunkName:"platform_homepage"*/ "./messageNotice.vue"));
